import React from 'react';

function Arrow(props) {
  return <svg viewBox="0 0 100 5">
  <polygon points="0,0 50,5 100,0" />
</svg>
}

export default Arrow;
